var _defs, _tspan, _tspan2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 120,
    height: 45,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 419.53h595.28V0H0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 419.53h595.28V0H0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(1.33333 0 0 -1.33333 -318.6 174.59)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-.634 0-1.167-.076-1.599-.208v-5.031l.66-.038c.229-.019.457-.019.685-.019 2.411 0 3.604.886 3.604 2.657C3.35-.886 2.233 0 0 0m4.923-5.521C3.806-6.313 2.182-6.709.076-6.709c-.33 0-.659 0-.99.019l-.685.038v-5.126h-3.146V.641c1.268.489 2.867.734 4.821.734 2.157 0 3.781-.377 4.872-1.149.99-.698 1.497-1.659 1.497-2.883 0-1.188-.482-2.149-1.522-2.864",
    style: {
      fill: "#6bbde2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(244.934 111.663)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0 .924-.254 1.602-.787 2.035-.507.434-1.345.66-2.512.66-.634 0-1.167-.076-1.598-.226l-.026-5.088c.229-.057.634-.095 1.218-.095C-1.244-2.714 0-1.809 0 .019zm.102-9.083-4.949 5.88h-.05v-5.88h-3.172l-.026 12.419c1.294.489 2.893.734 4.796.734 2.132 0 3.73-.339 4.821-1.036C2.614 2.337 3.146 1.376 3.146.113c0-.961-.431-1.753-1.294-2.393-.862-.622-1.979-.961-3.374-1.018v-.037l5.201-5.748z",
    style: {
      fill: "#6bbde2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(262.239 108.968)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-2.208 0-3.299-1.677-3.299-5.013 0-3.316 1.091-4.974 3.299-4.974 2.183 0 3.273 1.658 3.273 4.974C3.273-1.677 2.183 0 0 0m6.547-5.088c0-1.978-.507-3.543-1.523-4.692C3.883-11.081 2.208-11.74 0-11.74c-2.233 0-3.908.659-5.049 1.978-1.015 1.15-1.523 2.714-1.523 4.711 0 1.98.508 3.543 1.548 4.693C-3.882.942-2.208 1.602 0 1.602S3.883.942 5.024-.377C6.04-1.526 6.547-3.091 6.547-5.069z",
    style: {
      fill: "#6bbde2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(274.364 111.436)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-.432.622-1.167.942-2.208.942-.228 0-.457-.019-.66-.056v-8.217a3.09 3.09 0 0 1 .736-.075c1.015 0 1.726.302 2.157.904.406.604.609 1.715.609 3.317C.634-1.678.431-.622 0 0m3.958-7.953C2.613-9.291.533-9.95-2.259-9.95c-2.283 0-4.136.263-5.557.772l-.025 11.797c1.598.509 3.375.773 5.354.773 2.867 0 4.999-.641 6.369-1.941C5.075.32 5.659-1.263 5.659-3.279c0-1.979-.559-3.543-1.701-4.674",
    style: {
      fill: "#36828e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(291.465 109.646)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-1.319 0-1.979-1.376-1.979-4.108 0-2.733.66-4.089 1.979-4.089 1.294 0 1.954 1.356 1.954 4.089C1.954-1.376 1.294 0 0 0m5.405-8.951c-1.218-1.301-3.019-1.96-5.405-1.96s-4.212.64-5.456 1.941c-1.116 1.168-1.649 2.751-1.649 4.73 0 1.96.558 3.524 1.649 4.692C-4.212 1.771-2.386 2.431 0 2.431c2.386 0 4.187-.66 5.405-1.979C6.496-.716 7.055-2.28 7.055-4.24c0-1.979-.559-3.543-1.65-4.711",
    style: {
      fill: "#36828e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(306.207 110.607)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-.939-.528-2.284-.792-4.035-.792-2.361 0-4.161.679-5.405 2.054-1.091 1.206-1.65 2.752-1.65 4.617 0 1.847.584 3.373 1.726 4.599 1.269 1.375 3.045 2.072 5.38 2.072 1.7 0 3.019-.264 3.959-.773l-1.041-2.261c-.482.245-1.091.358-1.828.358-2.029 0-3.044-1.319-3.044-3.938 0-1.075.228-1.96.66-2.658.532-.81 1.319-1.206 2.359-1.206.635 0 1.244.114 1.802.34L-.025 0Z",
    style: {
      fill: "#36828e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(326.33 100.488)"
  })), /*#__PURE__*/React.createElement("text", {
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: "5.71540022px",
      fontFamily: "DaxRegular",
      InkscapeFontSpecification: "DaxRegular",
      writingMode: "lr-tb",
      fill: "#36828e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 1.25012 1.147 51.389)"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: "0 3.0005851 4.7655005 7.7077885 9.4224081 12.382414 14.63371 16.942732 18.320143 21.297867 24.344175 27.327614 28.716455 30.5511 32.128548 35.140564 38.11829 40.826817 43.815971 48.594044 51.577484 54.611217 56.445862 59.262409 61.097054 62.474464 65.452187 68.498497 70.750366 73.007378 75.796494 78.07579 79.852715 82.836151 87.614227",
    y: 0
  }, "\n\t\t\tProfessionelt dokumentationssystem\n\t\t")), _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: "24.759113 26.593756 27.971169 29.36001 30.93746 33.246483 36.224205 38.573235 39.950645 42.802631 44.191471 47.169197 51.947269 53.787628 56.639614 59.65163 62.599632",
    y: 6.858
  }, "\n\t\t\ttil socialomr\xE5det\n\t\t"))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)",
    transform: "matrix(1.33333 0 0 -1.33333 -318.6 174.59)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-7.443l-6.209-4.89z",
    style: {
      fill: "#6bbde2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(272.044 129.401)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-7.443l6.209-4.89z",
    style: {
      fill: "#36828e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(272.044 129.401)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-7.443l-6.209-4.89z",
    style: {
      fill: "#6bbde2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(285.882 129.401)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-7.443l6.209-4.89z",
    style: {
      fill: "#36828e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(285.882 129.401)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v7.443l-6.209 4.89z",
    style: {
      fill: "#6bbde2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(278.963 117.068)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-4.199-3.307v-7.443l3.518 6.988L2.01 1.583z",
    style: {
      fill: "#36828e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(283.163 127.818)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v7.443l-6.209 4.89z",
    style: {
      fill: "#6bbde2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(292.801 117.068)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-4.2-3.307v-7.443l3.519 6.988 2.69 5.345z",
    style: {
      fill: "#36828e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(297.001 127.818)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 3.045.942-.27-3.175",
    style: {
      fill: "#36828e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(296.14 128.554)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.059302613b6043519be36859d8055493.svg";
export { ForwardRef as ReactComponent };